module.exports = __webpack_public_path__ + "img/506-42dfb3.png";